<main>
    <div *ngIf="isloading" class="loader" style="top:100% !important;left:50%;"></div>

    <div class="wrapper" [ngClass]="{'expanded': isSidebarCollapsed}">
        <div class="container-fluid">
            <div class="row">
                <app-externalmenu></app-externalmenu>
            </div>
        </div>
        <div>
        </div>

        <div class="container-fluid pe-lg-3">
            <div class="row pe-0">
                <div class="col-12 d-none d-md-block">
                    <div class="d-flex align-items-center justify-content-between title">
                        <div class="d-flex align-items-left justify-content-start col-5">



                            <div class="d-flex align-items-baseline">
                                <!-- <h4>Axel Master List</h4> -->

                                <div class="btn-group" role="group">
                                    <button *ngFor="let btn of filterButtonsList" type="button btn-md" class="btn me-2"
                                        [ngClass]="{
                                 'btn-primary': btnType == btn.id,
                                 'btn-secondary': btnType != btn.id,
                                 'active': btnType == btn.id }" (click)="select(btn.id)">
                                        {{ btn.label }}
                                    </button>
                                </div>

                                
                            </div>
                        </div>
                        <div class="text-end d-flex justify-content-end align-items-center col-5" >

                            <div class="col-6">
                                         <div class="search ms-5 me-1">
                                <input type="text" class="form-control" placeholder="Search" [(ngModel)]="searchText">
                                <img src="/images/Magnifer.svg" alt="">
                            </div>
                            <!-- <div class="btn outline_lg_btn" (click)="applySearch()">Search</div> -->
                            </div>
                            <div class="col-3 ms-4">
                                   <div class="btn-group me-5" role="group">
                                    <button *ngFor="let btn of activeInActiveBtns" type="button btn-md" class="btn me-2"
                                        [ngClass]="{
                                 'btn-primary': btnStatusType == btn.id,
                                 'btn-secondary': btnStatusType != btn.id,
                                 'active': btnStatusType == btn.id }" (click)="selectStatusBtn(btn.id)">
                                        {{ btn.label }}
                                    </button>
                                </div>
                            </div>
                            
                        </div>
                        <div class="text-end chat_btn">
                            <button class="button" data-bs-toggle="modal" data-bs-target="#addModal" (click)="addNewWidget()">
                                <img src="images/add.svg" alt="" class="img-fluid me-1">{{btnType == 0 ? 'Add New' : btnType == 1 ? 'Add New Widget' : 'Add New Report' }}</button>
                        </div>
                    </div>

                </div>
            </div>

            <div class="row justify-content-between align-items-center">
                <div class="col-12 my-2 my-lg-2">
                    <!-- Tab Content -->
                    <!-- New -->

                    <div class="vehicle" role="tabpanel">
                        <div class="table-wrapper" style="max-height: calc(100vh - 170px) !important;">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Unique Id</th>
                                        <th>Type</th>
                                        <th>Module</th>
                                        <th>Title</th>
                                        <!-- <th>Description</th> -->
                                        <th>Schema</th>
                                        <th>API</th>
                                        <th>Xpert Model Id</th>
                                        <th>Status</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr *ngFor="let data of insightsdata">
                                        <td>{{ data.AXML_UNIQUE }}</td>
                                        <td>{{ data.AXML_TYPE == 1 ? 'Widget' : 'Report' }}</td>
                                        <td>{{ data.AXML_MODULE }}</td>
                                        <td>{{ data.AXML_TITLE }}</td>
                                        <!-- <td>{{ data.AXML_DESC }}</td> -->
                                        <td>{{ data.AXML_SCHEMA_INFO }}</td>
                                        <td>{{ data.AXML_API_INFO ? data.AXML_API_INFO : '-' }}</td>
                                        <td>{{ data.AXML_XPERT_MODELID ? data.AXML_XPERT_MODELID : '-' }}</td>
                                        <td [style.color]="data.AXML_STATUS == 'Y'? 'green' : 'red'">{{ data.AXML_STATUS == 'Y' ? 'Active' : 'InActive' }}</td>
                                        <td><img src="/images/EditPen.svg" (click)="editclick(data)"
                                                data-bs-toggle="modal" data-bs-target="#addModal" /></td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="text-center p-3" *ngIf="insightsdata.length == 0 && isloading == false">No data found</div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</main>

<div class="modal " id="addModal" tabindex="-1" aria-labelledby="addModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered Add">
        <div class="modal-content">

            <!-- Header -->
            <div class="modal-header border-0 ">
                <h5>{{headingType}}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <hr>
            <!-- Body -->
            <div class="modal-body">
                <form [formGroup]="widgetForm" novalidate>

                    <div class="form_wrapper">
                        <div class="form-floating">
                            <input type="text" class="form-control" id="uniqueIdInput" placeholder=" "
                                formControlName="uniqueid">
                            <label for="uniqueIdInput">Unique Id</label>
                        </div>
                        <div class="form-floating">
                            <input type="text" class="form-control" id="moduleinput" placeholder=""
                                formControlName="module">
                            <label for="moduleinput">Module</label>
                        </div>
                        <div class="form-floating ">
                            <input type="text" class="form-control" id="titleinput" placeholder=" "
                                formControlName="title">
                            <label for="titleinput">Title</label>
                        </div>
                        <!-- <div class="form-floating ">
                            <input type="email"  class="form-control" id="floatingInput" placeholder=""
                                formControlName="desc">
                            <label for="floatingInput">Decsription</label>
                        </div> -->
                        <div class="form-floating ">
                            <input type="text" class="form-control" id="schemainput" placeholder=" "
                                formControlName="schema">
                            <label for="schemainput">Schema</label>
                        </div>
                        <div class="form-floating ">
                            <input type="email" class="form-control" id="apiinput" placeholder="name@example.com"
                                formControlName="api">
                            <label for="apiinput">API</label>
                        </div>
                        <div class="form-floating ">
                            <input type="text" class="form-control" id="sequenceinput" placeholder=" "
                                formControlName="sequence">
                            <label for="sequenceinput">Sequence</label>
                        </div>
                        <div class="form-floating ">
                            <input type="text" class="form-control" id="xpertmodelinput" placeholder=" "
                                formControlName="xpertmodel">
                            <label for="xpertmodelinput">Xpert Model</label>
                        </div>
                        <div class="form-floating">
                            <div class="radio-buttons-container">
                                <div class="radio-button" >
                                    <input name="type" [value]="1" id="radio2" class="radio-button__input" type="radio" formControlName="type">
                                    <label for="radio2" class="radio-button__label">
                                        <span class="radio-button__custom"></span>Widget
                                    </label>
                                </div>
                                <div class="radio-button" >
                                    <input name="type" [value]="2" id="radio1" class="radio-button__input" type="radio" formControlName="type">
                                    <label for="radio1" class="radio-button__label">
                                        <span class="radio-button__custom"></span>Report
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="form-floating ">
                            <textarea rows="5" cols="5" class="form-control" id="descinput" placeholder=""
                                formControlName="desc"></textarea>
                            <label for="descinput">Decsription</label>
                        </div>
                        <div class="form-floating ">
                            <textarea rows="5" cols="5"  class="form-control" id="notesinput" placeholder=""
                                formControlName="notes"></textarea>
                            <label for="notesinput">Notes</label>
                        </div>
                        <div class="form-floating d-flex align-items-center" *ngIf="statusShow">
                                  <input type="checkbox" class="module-checkbox" [checked]="status == 'Y'" (change)="statusChange($event)">
                                  <span class="ms-2" [style.color]="status == 'Y' ? 'green' : 'red'">{{status == 'Y' ? 'Active' : 'InActive'}}</span>
                        </div>
                        
                    </div>
                </form>
            </div>
            <!-- Footer -->
            <div class="modal-footer border-0 mt-lg-3">
                <button type="submit" class="btn fill_lg_btn" (click)="onSave()">Submit</button>
                <button id="closeModalBtn" data-bs-dismiss="modal" hidden></button>
                <button type="button" class="btn fillgry_lg_btn" data-bs-dismiss="modal">Cancel</button>
            </div>
        </div>
    </div>
</div>